export default "__VITE_ASSET__5944ecd7__"